import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

document.addEventListener('DOMContentLoaded', function () {
  if (!window?.offerPopupConfig?.desktop || !window?.offerPopupConfig?.mobile) return;

  var offerPopupTrigger = document.querySelector('.open-offer');

  if (!offerPopupTrigger) return;

  offerPopupTrigger.addEventListener('click', function (e) {
    e.preventDefault();

    const desiredId =
      window.outerWidth > 768 ? window.offerPopupConfig?.desktop : window.offerPopupConfig?.mobile;

    if (!desiredId) return;

    // These form IDs may not be known by the popup monitor, so create them and push to the popups map, then open the popup

    const adapter = new KlaviyoPopupAdapter({
      id: desiredId,
      forceShow: true,
    });

    const popup = new Popup(adapter, {
      id: desiredId,
      displayName: 'Click here to see your discount',
    });

    window.popupMonitor.addPopup(popup);

    window.popupMonitor.showPopup(popup.getId());
  });
});
